module.exports = __webpack_public_path__ + "static/media/ThumbelinaBrown.717fb418.jpeg";